import type { ReactNode } from "react";
import type { LinkProps } from "@tanstack/react-router";
import type { Permission } from "@/api/types";
import { useCan } from "@/app/session";
import { PermissionDeniedPage } from "@/features/system/PermissionDeniedPage";

/** Renders the design's "Permission denied" screen in place when the user lacks `permission`. */
export function RequirePermission({
  permission,
  backTo,
  backLabel,
  children,
}: {
  permission: Permission;
  backTo: LinkProps["to"];
  backLabel: string;
  children: ReactNode;
}) {
  const can = useCan();
  if (!can(permission))
    return <PermissionDeniedPage permission={permission} backTo={backTo} backLabel={backLabel} />;
  return <>{children}</>;
}
